document.addEventListener('DOMContentLoaded', () => {

  /* ================================
     INIZIALIZZAZIONE MAPPA
     ================================ */
  
  const map = L.map('map', {
    
  minZoom: 2,
  worldCopyJump: false  // 👈 non può andare più lontano di 2
  
}).setView([43.77, 11.25], 3);

// Limiti dell’intero mondo
const worldBounds = [
  [-90, -180], // sud-ovest
  [90, 180]    // nord-est
];


map.setMaxBounds(worldBounds);

map.on('zoomend', updateMarkerSize);


L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=cb1_3xx0_1_b972ec4450ee6e40c1fe9fd3', {
  attribution: '&copy; OpenStreetMap &copy; CARTO',
  updateWhenZooming: false,
  keepBuffer: 4
}).addTo(map);
map.options.zoomAnimation = true;
map.options.fadeAnimation = true;
  /* ================================
     MARKER PERSONALIZZATO
     ================================ */

function getMarkerIcon(scale = 1) {
  const isMobile = window.innerWidth < 768;

  const baseSize = isMobile ? 60 : 88;
  const size = baseSize * scale;

  return L.icon({
    iconUrl: markerSvgUrl,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2]
  });
}

  /* ================================
     VARIABILI GLOBALI
     ================================ */

  const markers = [];
  const storesContainer = document.getElementById('stores');
  function updateMarkerSize() {
  const zoom = map.getZoom();

  let scale;

  if (zoom <= 3) {
    scale = 0.55;
  } else if (zoom <= 5) {
    scale = 0.7;
  } else if (zoom <= 7) {
    scale = 0.85;
  } else {
    scale = 1.1;
  }

  markers.forEach(marker => {
    marker.setIcon(getMarkerIcon(scale));
  });
}


  /* =====================================================
     ❌ RIMOSSO: FUNZIONE CALCOLO DISTANZA
     Motivo: non mostriamo più la distanza utente → negozio
     ===================================================== */
  /*
  function getDistanceFromLatLonInKm(...) { ... }
  */


  /* =====================================================
     ❌ RIMOSSO: GESTIONE GIORNI / ORARI
     Motivo: non mostriamo più gli orari di apertura
     ===================================================== */
  /*
  const days = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
  const todayKey = days[new Date().getDay()];
  */


  /* ================================
     CARICAMENTO JSON BOUTIQUE
     ================================ */

  fetch(boutiquesJsonUrl)
    .then(res => res.json())
    .then(data => {

      data.forEach((storeData, index) => {

        /* ==========================================
           DATI NECESSARI
           ❌ Rimossi: hours, distance, link esterni
           ========================================== */
        const { lat, lng, city, address, name } = storeData;


        /* ================================
           CARD STORE (HTML)
           ================================ */

        const storeDiv = document.createElement('div');
        storeDiv.className = 'store';

        storeDiv.dataset.lat = lat;
        storeDiv.dataset.lng = lng;
        storeDiv.dataset.city = city.toLowerCase();

        /* =====================================================
           ❌ RIMOSSO:
           - orari
           - distanza
           - link "come arrivare"
           ===================================================== */
        storeDiv.innerHTML = `
          <strong>${name}</strong>
          <p>${address}</p>
        `;

        storesContainer.appendChild(storeDiv);


        /* ================================
           MARKER SU MAPPA
           ================================ */

        const marker = L.marker([lat, lng], { icon: getMarkerIcon(0.6) }).addTo(map);
        markers.push(marker);


        /* ================================
           INTERAZIONI
           ================================ */
storeDiv.addEventListener('click', () => {
  // Centra la mappa sul marker
  map.setView([lat, lng], 13);

  // Porta la card in cima al container
  storesContainer.insertBefore(storeDiv, storesContainer.firstChild);

  // Scrolla il container per farla vedere in cima
  storesContainer.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
});


const mapCenter = map.getCenter(); // ritorna {lat, lng}

function getDistance(lat1, lng1, lat2, lng2) {
  const R = 6371; // raggio Terra in km
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng/2) * Math.sin(dLng/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
}

function sortStoresByDistance(refLat, refLng) {
  const storesArray = Array.from(storesContainer.children);

  storesArray.sort((a, b) => {
    const aLat = parseFloat(a.dataset.lat);
    const aLng = parseFloat(a.dataset.lng);
    const bLat = parseFloat(b.dataset.lat);
    const bLng = parseFloat(b.dataset.lng);

    const distA = getDistance(refLat, refLng, aLat, aLng);
    const distB = getDistance(refLat, refLng, bLat, bLng);

    return distA - distB; // dal più vicino al più lontano
  });

  // Applica l'ordine al DOM
  storesArray.forEach(store => storesContainer.appendChild(store));
}





marker.on('click', () => {
  map.setView([lat, lng], 13);

  // Ordina tutte le card rispetto al marker cliccato
  sortStoresByDistance(lat, lng);

  // Scrolla il container in cima alla card cliccata
  storesContainer.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
});



        // Hover marker → evidenzia card
        marker.on('mouseover', () => {
          storeDiv.classList.add('active');
        });
        marker.on('mouseout', () => {
          storeDiv.classList.remove('active');
        });

        // Hover card → evidenzia marker
        storeDiv.addEventListener('mouseover', () => {
          if (marker._icon) marker._icon.classList.add('marker-hover');
        });
        storeDiv.addEventListener('mouseout', () => {
          if (marker._icon) marker._icon.classList.remove('marker-hover');
        });


        /* =====================================================
           ❌ RIMOSSO: GEOLOCALIZZAZIONE UTENTE
           Motivo:
           - non serve più
           - evita richiesta permessi browser
           - migliora UX e performance
           ===================================================== */
        /*
        navigator.geolocation.getCurrentPosition(...)
        */

      });


      /* ================================
         FIT AUTOMATICO SU TUTTI I MARKER
         ================================ */

      if (markers.length) {
        const group = L.featureGroup(markers);
        map.fitBounds(group.getBounds().pad(0.2));
      }

      updateMarkerSize();
      /* ================================
         FILTRO PER CITTÀ
         ================================ */

      const search = document.getElementById('search');
      if (search) {
        search.addEventListener('input', e => {
          const value = e.target.value.toLowerCase();

          document.querySelectorAll('.store').forEach((store, index) => {
            const isVisible = store.textContent.toLowerCase().includes(value);
            store.style.display = isVisible ? 'block' : 'none';

            // mostra/nasconde marker
            if (markers[index]) {
              if (isVisible) {
                markers[index].addTo(map);
              } else {
                map.removeLayer(markers[index]);
              }
            }
          });

          // aggiorna bounds solo marker visibili
          const visibleMarkers = markers.filter(marker => map.hasLayer(marker));
          if (visibleMarkers.length) {
            const group = L.featureGroup(visibleMarkers);
            map.fitBounds(group.getBounds().pad(0.2));
          }
        });
      }

    })
    .catch(err => console.error('Errore caricamento JSON boutique:', err));

});
